// src/components/AddCompanyForm/SocialsCard.jsx
import React from "react";
import { Card, CardHeader, CardContent, Grid, TextField, InputAdornment } from "@mui/material";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";

export default function SocialsCard({ form, setForm }) {
  const set = (patch) => setForm((p) => ({ ...p, ...patch }));
  return (
    <Card variant="outlined">
      <CardHeader title="Redes sociais" subheader="URLs completas" />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              label="Facebook"
              value={form.facebook}
              onChange={(e) => set({ facebook: e.target.value })}
              fullWidth
              placeholder="https://facebook.com/sua-pagina"
              InputProps={{ startAdornment: <InputAdornment position="start"><LinkRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              label="Instagram"
              value={form.instagram}
              onChange={(e) => set({ instagram: e.target.value })}
              fullWidth
              placeholder="https://instagram.com/seu-perfil"
              InputProps={{ startAdornment: <InputAdornment position="start"><LinkRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              label="YouTube"
              value={form.youtube}
              onChange={(e) => set({ youtube: e.target.value })}
              fullWidth
              placeholder="https://youtube.com/@seucanal"
              InputProps={{ startAdornment: <InputAdornment position="start"><LinkRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              label="LinkedIn"
              value={form.linkedin}
              onChange={(e) => set({ linkedin: e.target.value })}
              fullWidth
              placeholder="https://www.linkedin.com/company/sua-empresa"
              InputProps={{ startAdornment: <InputAdornment position="start"><LinkRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
